import { isUndefined } from 'lodash'
import { removeItem } from './utils'
import {
  REMOVE_INTEREST_LOADING,
  REMOVE_INTEREST_FAILURE,
  REMOVE_INTEREST_SUCCESS,
} from '../../actions'

const removingInterestReducer = (prevState = {}, { type, payload }) => {
  switch (type) {
    case REMOVE_INTEREST_LOADING:
      return {
        ...prevState,
        [payload]: true,
      }
    case REMOVE_INTEREST_SUCCESS:
    case REMOVE_INTEREST_FAILURE:
      return {
        ...prevState,
        [payload]: false,
      }
    default:
      return prevState
  }
}

const itemsInterestReducer = (
  prevState = { interestsRemovingById: {} },
  action
) => {
  switch (action.type) {
    case REMOVE_INTEREST_LOADING:
    case REMOVE_INTEREST_FAILURE:
    case REMOVE_INTEREST_SUCCESS: {
      if (!isUndefined(prevState.data[action.payload])) {
        const nextState = {
          ...prevState,
          interestsRemovingById: removingInterestReducer(
            prevState.interestsRemovingById,
            action
          ),
        }
        if (action.type === REMOVE_INTEREST_SUCCESS) {
          return removeItem(nextState, action.payload)
        }
        return nextState
      }
    }
    default:
      return prevState
  }
}

export default itemsInterestReducer



// WEBPACK FOOTER //
// ./src/reducers/items/interest.js